import React from "react";
import { Col, Container, Row, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import Linkedin from "../../../assets/images/linkedin.svg";
import Twitter from "../../../assets/images/twitter.svg";
import Telegram from "../../../assets/images/telegram.svg";
import CoinMarketLogo from "../../../assets/images/coin-market-alert.png";
import LittleCaptain from "../../../assets/images/little-captain-logo.png";
import "./Footer.css";
function Footer() {
  return (
    <footer className="footer">
      <Container fluid className="custom-container">
        <ul className="social-icons mb-0 d-flex justify-content-center ps-0">
          <li className="">
            <Link to="/">
              <Image src={Linkedin} fluid />
            </Link>
          </li>
          <li className="">
            <Link to="/">
              <Image src={Twitter} fluid />
            </Link>
          </li>
          <li className="">
            <Link to="/">
              <Image src={Telegram} fluid />
            </Link>
          </li>
        </ul>
        <Row>
          <Col lg={4}>
            <ul className="nav-links text-lg-start text-center list-unstyled">
              <li className="">
                <a
                  href="https://coinmarketalert.com/terms-conditions/"
                  className="text-white text-decoration-none"
                  target="_blank"
                >
                  Terms And Conditions
                </a>
              </li>

              <li className="">
                <a
                  href="https://coinmarketalert.com/privacy-policy/"
                  className="text-white text-decoration-none"
                  target="_blank"
                >
                  {" "}
                  Privacy Policy
                </a>
              </li>
            </ul>
          </Col>
          <Col lg={4}>
            <div className="coin-market-logo text-center d-lg-block d-none">
              <Image src={CoinMarketLogo} fluid />
            </div>
          </Col>
          <Col lg={4}>
            <ul className="nav-links text-lg-end text-center list-unstyled">
              <li className="">
                <Link to="/partner"> Reward Partners</Link>
              </li>
              <li className="">
                <a
                  href="https://coinmarketalert.com/coin-market-contact/"
                  className="text-white text-decoration-none"
                  target="_blank"
                >
                  {" "}
                  Contact
                </a>
              </li>
            </ul>
          </Col>
        </Row>
        <div className="coin-market-logo text-center d-lg-none d-block">
          <Image src={CoinMarketLogo} fluid />
        </div>
        <div className="text-center">
          <span className="design-by">DESIGNED BY</span>
          <Image src={LittleCaptain} fluid />
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
